import DEstudiante from "./estudiante";

export const colegio_documentos_pantallas={
    DEstudiante
}